import { PaginationTable } from '../../../common';

const PaymentsPagination = ({
  totalPages,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => (
  <PaginationTable
    totalPages={totalPages}
    totalCount={totalCount}
    page={page}
    rowsPerPage={rowsPerPage}
    onPageChange={onPageChange}
    onRowsPerPageChange={onRowsPerPageChange}
  />
);

export default PaymentsPagination;
